export const isStatic = (fieldType: string) => ["Separator", "Text"].includes(fieldType);
